import { withI18n } from 'panda-i18n';
import { componentName } from './constant';
import locale from '@/locale';
import CnResultView from './cn-result-view';
export var CnResult = withI18n(CnResultView, {
    componentName: componentName,
    locale: locale,
});
